module.exports = __webpack_public_path__ + "img/4.3f31af84.png";